module.exports = __webpack_public_path__ + "img/SSLRSMD.b90989e5.svg";